<template>
  <q-item dense>
    <q-item-section class="col-auto">
      <q-checkbox
        :model-value="modelValue"
        :label="descendant.label"
        :disable="!selectable"
        @update:model-value="value => $emit('update:model-value', value)"
      />
    </q-item-section>
    <q-item-section class="col-auto">
      <div
        class="text-body-em text-grey-8"
        style="font-size: 14px;"
      >
        ID {{ descendant.id }}
      </div>
    </q-item-section>
    <q-item-section>
      <div class="col row items-center justify-end">
        <archive-status-chip :descendant="descendant" />
        <link-status-chip :descendant="descendant" />
        <q-btn
          icon="more_vert"
          dense
          round
          :hover="false"
          size="sm"
          @click.stop
        >
          <q-menu>
            <q-list style="min-width: 180px">
              <template v-if="descendant.archivable && isDeletePermitted">
                <q-item
                  v-if="!descendant.isArchived"
                  v-close-popup
                  :disable="!isDeletePermitted"
                  clickable
                  @click="$emit('archive', descendant)"
                >
                  <q-item-section avatar>
                    <q-icon name="archive" />
                  </q-item-section>
                  <q-item-section>
                    Archive
                  </q-item-section>
                  <action-not-permitted-tooltip
                    v-if="!isDeletePermitted"
                    action="delete"
                  />
                </q-item>
                <q-item
                  v-else
                  v-close-popup
                  :disable="!isDeletePermitted"
                  clickable
                  @click="$emit('unarchive', descendant)"
                >
                  <q-item-section avatar>
                    <q-icon name="unarchive" />
                  </q-item-section>
                  <q-item-section>
                    Unarchive
                  </q-item-section>
                  <action-not-permitted-tooltip
                    v-if="!isDeletePermitted"
                    action="delete"
                  />
                </q-item>
              </template>
              <q-separator v-if="$admin && versioned" />
              <q-item
                v-if="$admin && versioned"
                v-close-popup
                clickable
                @click="$emit('show-history', descendant)"
              >
                <q-item-section avatar>
                  <q-icon name="history" />
                </q-item-section>
                <q-item-section>
                  View History
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </div>
    </q-item-section>
  </q-item>
</template>

<script>
import ActionNotPermittedTooltip from 'src/modules/admin/components/ModelForm/components/ActionNotPermittedTooltip'
import ArchiveStatusChip from 'src/modules/admin/components/ModelForm/components/library/ArchiveStatusChip'
import LinkStatusChip from 'src/modules/admin/components/ModelForm/components/library/LinkStatusChip'

export default {
  name: 'LinkToModelItem',
  components: {
    ArchiveStatusChip,
    LinkStatusChip,
    ActionNotPermittedTooltip
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    descendant: {
      type: Object,
      required: true
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    versioned: {
      type: Boolean,
      required: false,
      default: false
    },
    isDeletePermitted: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'archive', 'unarchive', 'show-history']
}

</script>

<style lang="scss" scoped>
  .q-checkbox {
    :deep(.q-checkbox__bg) {
      border-radius: 6px;
    }
    :deep(.q-checkbox__svg) {
      width: 75% !important;
      height: 75% !important;
      margin: auto;
    }
  }
</style>
